<ng-container [ngSwitch]="searchResult.type">
  <ng-container *ngSwitchCase="searchIndexType.Recording">
    <ng-container *ngIf="searchRequestType === searchRequestTypes.AllRecordings; else thisRecordingSearchReturnItem">
      <ftr-search-results-all-recordings-item
        class="search-result-item"
        [hasLink]="hasLink"
        [searchResult]="asIndexedRecording(searchResult.body)"
        [courtSystemConfig]="courtSystemConfig"
      >
      </ftr-search-results-all-recordings-item>
    </ng-container>
    <ng-template #thisRecordingSearchReturnItem>
      <ftr-search-results-this-recording-item
        class="search-result-item"
        [searchResult]="asThisRecordingSearchResult(searchResult)"
        [courtSystemConfig]="courtSystemConfig"
      >
      </ftr-search-results-this-recording-item>
    </ng-template>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ftr-search-results-orders-item
      class="search-result-item"
      [hasLink]="hasLink"
      [courtSystemConfig]="courtSystemConfig"
      [highlight]="highlight"
      [searchResult]="asIndexedOrder(searchResult.body)"
      [getValue]="getValue.bind(this)"
      [dynamicHighlight]="dynamicHighlight"
    >
    </ftr-search-results-orders-item>
  </ng-container>
</ng-container>
<ng-content></ng-content>
